import React from 'react';
import { useAppSelector } from 'store/hooks';

import { userSelector } from 'store/auth/selectors';

import ProfilePage from './ProfilePage';

const AdminPageContainer = () => {
  const user = useAppSelector(userSelector);

  return (
    <>
      <ProfilePage user={user} />
    </>
  );
};

export default React.memo(AdminPageContainer) as any;
